export function appDestination(baseUrl, destination, websiteOrigin) {
  try {
    const base = new URL((baseUrl || "").trim());
    if (!["http:", "https:"].includes(base.protocol) || base.username || base.password || base.origin === websiteOrigin) return null;
    if (!/^\/(business|control)(\/|$)/.test(destination) && destination !== "/login?type=personal") return null;
    if (!destination.startsWith("/") || destination.startsWith("//")) return null;
    const target = new URL(destination, base.origin);
    return target.origin === base.origin ? target.href : null;
  } catch { return null; }
}
